import { memo } from 'react';

import UsersIconSVG from '@/assets/users-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IUsersIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={UsersIconSVG} {...props} />;

export const UsersIcon = memo(IUsersIcon) as typeof IUsersIcon;
